var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"body-1 font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.$tc('page.survey.intro.language.text'))}}),_c('os-language-selection',{staticClass:"mt-10",attrs:{"type":"list","lang":_vm.internalValue,"show-all-supported-languages":true},on:{"click:flag":_vm.changeLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }